import { cn } from "@/lib/utils";
import type { ReactNode, HTMLAttributes } from "react";

type TradingPanelCardProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  className?: string;
  noPadding?: boolean;
};

export const TradingPanelCard = ({
  children,
  className,
  noPadding = false,
  ...props
}: TradingPanelCardProps) => {
  return (
    <div
      className={cn(
        "h-full rounded-lg bg-card border border-border/40",
        !noPadding && "p-2",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
